/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum IdTypeApiModel {
  Phone = 'phone',

  Qr = 'qr',

  Email = 'email',

  Card = 'card',

  TemporaryCard = 'temporary-card',

  Id = 'id',

  ExternalId = 'external-id',

  SocialNetwork = 'social-network',

  Ssn = 'ssn',

  Itin = 'itin',

  Itn = 'itn'
}
